import React, { FC } from "react"
import styled, { css } from "styled-components"
import Title from "./title"
import { Paragraph } from "./UIKit/system"
import ArrowInCircle from "./arrow-in-circle"
import Link from "./link"
import LazyImage from "./lazy-image"
import mq from "../utils/mq"

export interface InfoImageCardProps {
  title: string;
  text: string;
  keyPoints?: {
    title: string;
    text: string;
  }[];
  image: { [key: string]: unknown };
  link?: {
    to: string;
    title: string;
  };
}

const InfoImageCard: FC<InfoImageCardProps> = (props) => {
  const { title, text, link, image, keyPoints } = props

  return (
    <StyledContainer>
      <StyledInfoBlock>
        <Title color="white" fontSizeSmall mb={16}>{title}</Title>
        <Paragraph lightGrey>{text}</Paragraph>
        {keyPoints && (
          <StyledKeyPoints>
            {keyPoints.map((point) => (
              <div key={point.title}>
                <Paragraph color="white">{point.title}</Paragraph>
                <Paragraph lightGrey>{point.text}</Paragraph>
              </div>
            ))}
          </StyledKeyPoints>
        )}
        {link && (
          <StyledLink to={link.to} color="white" hover>
            <ArrowInCircle white />
            {link.title}
          </StyledLink>
        )}
      </StyledInfoBlock>
      <LazyImage fluid={image} />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 50%;
  height: 100%;

  ${mq.mobile(css`
    grid-auto-flow: row;
    grid-template-columns: none;
  `)}
`

const StyledInfoBlock = styled.div`
  background-color: #ffffff05;
  display: grid;
  grid-template-rows: auto auto auto 1fr;
  padding: 72px;

  ${mq.mobile(css`
    padding: 30px;
  `)}
`

const StyledKeyPoints = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  row-gap: 20px;
  column-gap: 17px;
  margin-top: 24px;

  ${mq.tablet(css`
    grid-auto-flow: row;
    grid-template-columns: none;
    row-gap: 10px;
  `)}
`

const StyledLink = styled(Link)`
  align-items: center;
  align-self: end;
  display: inline-grid;
  grid-auto-flow: column;
  justify-self: start;
  gap: 11px;
  margin-top: 46px;
`

export default InfoImageCard
